(function () {
  function slideOffset(slider, slides) {
    const visible = Array.from(slides).filter((el) => el.clientWidth > 0);
    if (visible.length < 2) return slider.clientWidth || 1;
    return visible[1].offsetLeft - visible[0].offsetLeft;
  }

  function wireProductGalleryDots(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const dotsRoot = gallery.querySelector('.product__media-dots');
    if (!viewer || !dotsRoot || viewer.dataset.productGalleryDotsWired === 'true') return;
    viewer.dataset.productGalleryDotsWired = 'true';

    const slider = viewer.querySelector('[id^="Slider-"]');
    const slides = viewer.querySelectorAll('[id^="Slide-"]');
    const dots = dotsRoot.querySelectorAll('[data-product-gallery-dot]');

    const setActiveDot = (page) => {
      const n = typeof page === 'number' ? page : 1;
      dots.forEach((dot, i) => {
        const on = i + 1 === n;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-product-gallery-dot'), 10);
        if (!slider || !index) return;
        const off = slideOffset(slider, slides);
        slider.scrollTo({ left: (index - 1) * off, behavior: 'smooth' });
      });
    });

    viewer.addEventListener('slideChanged', (event) => {
      const page = event.detail && event.detail.currentPage;
      if (page) setActiveDot(page);
    });

    setActiveDot(1);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(wireProductGalleryDots);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
